import axios from 'axios';
import config from '@/config/env-constants';

export default {

    saveAssetType(param) {
        let url = `${config.cloudFunctionsBaseUrl}/saveAssetType`;
        return axios.post(url, {
            currUserId: param.currUserId,
            assetType: JSON.stringify(param.assetType)
        });
    },

    getAssetType(param) {
        let url = `${config.cloudFunctionsBaseUrl}/getAssetType`;
        return axios.post(url, {
            currUserId: param.currUserId,
            assetTypeId: param.assetTypeId
        });
    },

    getAssetTypes(filterBy, view, currUserId, pagination = {}) {
        let url = `${config.cloudFunctionsBaseUrl}/getAssetTypes`;
        return axios.post(url, {
            view: view,
            currUserId: currUserId,
            filterBy: JSON.stringify(filterBy),
            search: pagination.search,
            page: pagination.page,
            pageSize: pagination.pageSize,
        });
    },

    getAssetTypeCodes(filterBy, view, currUserId, pagination = {}) {
        let url = `${config.cloudFunctionsBaseUrl}/getAssetTypeCodes`;
        return axios.post(url, {
            view: view,
            currUserId: currUserId,
            filterBy: JSON.stringify(filterBy),
            search: pagination.search,
            page: pagination.page,
            pageSize: pagination.pageSize,
        });
    },
}